// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_mn-0";
export var animationContainer = "_mn-1";
export var itemPrice = "_mn-a";
export var itemizedContent = "_mn-9";
export var itemizedHeader = "_mn-7";
export var itemizedRow = "_mn-8";
export var itemizedSection = "_mn-6";
export var modalContent = "_mn-2";
export var orderName = "_mn-3";
export var refundOption = "_mn-4";
export var refundOptionsContainer = "_mn-5";
export var shippingLabel = "_mn-b";
export var totalRow = "_mn-c";